(function (){
  'use strict';

  angular
      .module('tfc.Products')
      .factory('ProductMgr', ProductMgr)
      .constant('noCacheHeader', {
        headers : {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      });


  // @ngInject
  function ProductMgr($q, Api, $state, $cacheFactory, util, Upload,BrandReports,ExcelReportType, noCacheHeader) {
    var BASE_URL = '/brand/';
    var cache = $cacheFactory('Products');

    return {
      upload: upload,
      findFiles: findFiles,
      findRecentFiles: findRecentFiles,
      findMissingStyles: findMissingStyles,
      findStyleSummary: findStyleSummary,
      getReport: getReport
    };

    function upload(files, brandKey) {
      var data = {files: files};
      return Upload.upload({
        method : 'POST',
        url :  Api.getBasePath() + Api.withEncodedPath(BASE_URL,brandKey),
        data : data
      }).then(clearCache);
    }

    function findFiles(fileIdentifier, brandKey) {
        var config = { params : fileIdentifier };
        config = _.extend(config, noCacheHeader);
        return Api.get(Api.withEncodedPath(BASE_URL, brandKey), config).then(getResponseData);
    }

    function findStyleSummary(brandKey) {
        return Api.get(Api.withEncodedPath(BASE_URL, brandKey) + '/styleSummary').then(getResponseData);
    }

    function findRecentFiles(brandKey) {
        return Api.get(Api.withEncodedPath(BASE_URL, brandKey) + '/recent', noCacheHeader).then(getResponseData);
    }

    function clearCache(response) {
      cache.removeAll();
      return response.data;
    }

    function findMissingStyles(fileIdentifier, brandKey) {
      return Api.get(Api.withEncodedPath(BASE_URL, brandKey) +'/missingStyles/live',{ params : fileIdentifier })
            .then(getResponseData);
    }

    function getReport(brandKey) {
      return Api.get(Api.withEncodedPath(BASE_URL, brandKey) + '/missingStyles/report', {
          cache: true, // Can always cache content
          responseType: 'arraybuffer',
          headers: {
            'Accept': ExcelReportType
          }
        }).then(function (response) {
          // parse the header as a map
          var disposition = util.parseMultipartHeader(response.headers('content-disposition'));
          return $q.all({
            fileName: disposition.filename,
            dataBlob: new Blob([response.data], {type: disposition['content-type']})
          });
      });
    }

    function unpack(response) { return response.data.value; }
    function getResponseData(response) { return response.data; }
  }
})();